import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { FinishRegistrationInput } from "generated/graphql";
import { SubmitHandler, useForm } from "react-hook-form";
import { zodPasswordValidator } from "utils/validations/isValidPassword";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod";
import MDTypography from "components/MDTypography";
import { zodEmailValidator } from "utils/validations/isValidEmail";
import MDPasswordInput from "components/MDPasswordInput/MDPasswordInput";

export interface CompleteSignUpFormProps {
  onSubmit: SubmitHandler<FinishRegistrationInput>;
  loading: boolean;
  email: FinishRegistrationInput["email"];
  token: FinishRegistrationInput["token"];
}

const schema = z.object({
  password: zodPasswordValidator,
  email: zodEmailValidator,
  token: z.string(),
});

export default function CompleteSignUpForm({
  onSubmit,
  loading,
  email,
  token,
}: CompleteSignUpFormProps) {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<FinishRegistrationInput>({
    resolver: zodResolver(schema),
    defaultValues: {
      email,
      token,
      password: "",
    },
  });

  return (
    <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
      <MDBox mb={2}>
        <input type="hidden" {...register("email")} />
        <input type="hidden" {...register("token")} />
        <MDPasswordInput
          type="password"
          label="Password"
          variant="standard"
          placeholder="Password"
          fullWidth
          required
          {...register("password")}
          errror={errors.password}
        />
        {errors.password && (
          <MDTypography color="error" variant="caption">
            {errors.password.message}
          </MDTypography>
        )}
      </MDBox>
      <MDBox mt={4} mb={1}>
        <MDButton variant="gradient" color="info" fullWidth type="submit" disabled={loading}>
          Complete
        </MDButton>
      </MDBox>
    </MDBox>
  );
}
